/* global $crisp */

export default function () {
  $('body')
    .on('click', '[data-show-crisp]', (e) => {
      e.preventDefault();
      $crisp.push(['do', 'chat:open']);
    })
    .on('click', '[data-crisp-from-dropdown]', (e) => {
      $(e.currentTarget).closest('[data-dropdown]').foundation('close');
      $crisp.push(['do', 'chat:open']);
    });
}
